import { render, staticRenderFns } from "./DiscountTargetMember.vue?vue&type=template&id=21577b57&"
import script from "./DiscountTargetMember.vue?vue&type=script&lang=ts&"
export * from "./DiscountTargetMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports